const BRISBANE_OFFSET_MINUTES = 10 * 60;
const BRISBANE_OFFSET_MS = BRISBANE_OFFSET_MINUTES * 60 * 1000;
export const BRISBANE_TIME_ZONE = 'Australia/Brisbane';

function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

function parseInputParts(input: string): [number, number, number, number, number] | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(input);
  if (!match) return null;
  return match.slice(1).map(Number) as [number, number, number, number, number];
}

function formatFromUtcParts(date: Date): string {
  return [
    date.getUTCFullYear(),
    pad(date.getUTCMonth() + 1),
    pad(date.getUTCDate()),
  ].join('-') + `T${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
}

export function utcIsoToBrisbaneInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const utcDate = new Date(iso);
  if (Number.isNaN(utcDate.getTime())) return '';
  return formatFromUtcParts(new Date(utcDate.getTime() + BRISBANE_OFFSET_MS));
}

export function brisbaneInputToUtcIso(input: string): string | null {
  const parts = parseInputParts(input);
  if (!parts) return null;
  const [year, month, day, hours, minutes] = parts;
  const utcMs = Date.UTC(year, month - 1, day, hours, minutes) - BRISBANE_OFFSET_MS;
  return new Date(utcMs).toISOString();
}

export function isBrisbaneInputInFuture(input: string): boolean {
  const iso = brisbaneInputToUtcIso(input);
  if (!iso) return false;
  return new Date(iso).getTime() > Date.now();
}

export function getDefaultBrisbaneInput(minutesFromNow = 5): string {
  const brisbaneMs = Date.now() + BRISBANE_OFFSET_MS + minutesFromNow * 60 * 1000;
  return formatFromUtcParts(new Date(brisbaneMs));
}

export function formatUtcToBrisbane(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return `${new Intl.DateTimeFormat('en-AU', {
    timeZone: BRISBANE_TIME_ZONE,
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date)} AEST`;
}
